export enum BeneficialOwnerIncomeSourceType {
  WAGES = 'WAGES',
  COMPANY_EARNINGS = 'COMPANY_EARNINGS',
  INHERITANCE = 'INHERITANCE',
  DEPOSIT_INTEREST = 'DEPOSIT_INTEREST',
  OTHER = 'OTHER'
}

export enum PrimaryIncomeSourceType {
  COMPANY_EARNINGS = 'COMPANY_EARNINGS',
  OTHER = 'OTHER'
}
